import AgentListing from "./AgentListing.container";

export default AgentListing;
